import { render, staticRenderFns } from "./StainedGlassBuilder.vue?vue&type=template&id=f80e2d44&scoped=true&"
import script from "./StainedGlassBuilder.vue?vue&type=script&lang=ts&"
export * from "./StainedGlassBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./StainedGlassBuilder.vue?vue&type=style&index=0&id=f80e2d44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80e2d44",
  null
  
)

export default component.exports